import React from 'react';
import Icon from './Icon';
import colors from '../Theme/colors';

interface FilterProperties {
  fill?: string;
}

const Filter = ({
  fill = colors.blackMedium,
  ...properties
}: FilterProperties) => (
  <Icon {...properties}>
    <rect x="0" y="14.4" width="34" height="5" fill={fill} />
    <rect x="5.5" y="24.5" width="23" height="5" fill={fill} />
    <rect x="11" y="35" width="12" height="5" fill={fill} />
  </Icon>
);

export default Filter;
